import { IconButton, Tooltip } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import MenuBookIcon from '@mui/icons-material/MenuBook';

function UserGuidesRedirect() {
  const { pathname } = useLocation();

  return (
    <Tooltip title="Centro de Recursos">
      <IconButton
        color="inherit"
        size="large"
        component={Link}
        to={`/configuracion/centrorecursos?view=${encodeURIComponent(pathname)}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <MenuBookIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}

export default UserGuidesRedirect;
